module.exports = __webpack_public_path__ + "media/images/lp_v6_01-2991de764ad4ea49383e658de3f3c827.webp";